import { BlocksMainScene } from './blocks-main-scene';
import { BlocksApp } from '../blocks-app';
import { GameBaseScene } from 'src/games/common/phaser/game/scenes/game-base-scene';
import { BlocksListener } from '../blocks-listener';
import { TranslocoService } from '@jsverse/transloco';

export class BlocksPreloadScene extends GameBaseScene {
  public static get className(): string {
    return BlocksPreloadScene.name;
  }

  constructor(private localAssetPath: string) {
    super(BlocksPreloadScene.className);
  }

  public setGameListener(gameListener: BlocksListener) {
    BlocksApp.getInstance().setGameListener(gameListener);
  }

  public preloadTranslations(translocoService: TranslocoService): void {
    BlocksApp.getInstance().preloadTranslations(translocoService);
  }

  public preload() {
    BlocksApp.getInstance().preloadAssets(this, this.localAssetPath);
  }

  protected override onLoadProgress(progress: number) {
    super.onLoadProgress(progress);
  }

  protected override onLoadComplete() {
    super.onLoadComplete();

    this.scene.start(BlocksMainScene.className);
  }
}
